<template>
  <el-date-picker :clearable="clearable" 
    v-model="time" type="daterange" :picker-options="pickerOptions"
    @change="timeChange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始"
    end-placeholder="结束"
    :default-time="['00:00:00', '23:59:59']"
  ></el-date-picker>
</template>

<script>
/**
 * 日期区间选择
 */
export default {
  props: {
    value: {
      type: Array,
      default: ()=>[]
    },
    clearable: {
      type: Boolean,
      default: true,
    }
  },
  watch: {
    value () {
      this.initvalue()
    }
  },
  data () {
    const vm = this
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      time: [],
    }
  },
  created () {
    this.initvalue()
  },
	methods: {
		/**
     * 日期改变
     */
    timeChange() {
      if(!this.time){
        this.time = []
      }

      let start = ''
      if(this.time[0]){
        start = this.time[0].split(' ')[0] + ' 00:00:00'
      }

      let end = ''
      if(this.time[1]){
        end = this.time[1].split(' ')[0] + ' 23:59:59'
      }

      this.$emit('change1', start)
      this.$emit('change2', end)
    },
    initvalue () {
      if(this.value[1]){
        this.time = this.value
      }else{
        this.time = []
      }
    },
    /**
     * 清除
     */
    clear () {
      this.time = []
    }
	}
}
</script>

<style lang="scss" scoped type="text/css">

</style>